<header id="header" role="banner" class="up-delay up print-onfirstpage">
  <div id="top-bar" class="d-lg-none">
    <div class="container container-wide-header-menu">
      <ul id="top-bar-menu" class="row">        
        <li id="menu-item-4280" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4280">
          <a href="{{fmpUrl}}" target="_blank">Fluid Approval </a>
        </li>
        <li id="menu-item-4280" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4280">
          <a [routerLink]="fspUrl">Fluid Selector</a>
        </li>
        <li id="menu-item-4280" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4280">
          <a href="{{fmpSupportUrl}}" target="_blank">Support </a>
        </li>
        <li *ngIf="loggedIn" id="menu-item-4280" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-4280">
          <a [routerLink]="fmpAdminUrl">Admin</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="container container-wide d-flex align-items-center">
    <a class="logo" href="https://allisonoffhighway.com/">
      <img src="assets/Logo-allison-oh-1x5-1.png" alt="Allison Off-Highway">
    </a>

    <div class="d-none d-md-flex ms-auto" id="top-bar-menu">
      <ul id="top-bar-menu">
        <div class="row">
          <div class="btn btn-default btn-sm text-white btn-primary btn-round headerMenu col-form-label"><a href="{{fmpUrl}}" target="_blank">Fluid Approval </a></div>
          <div class="btn btn-default btn-sm text-white btn-primary btn-round headerMenu col-form-label"><a [routerLink]="fspUrl">Fluid Selector</a></div>
          <div class="btn btn-default btn-sm text-white btn-primary btn-round headerMenu col-form-label"><a href="{{fmpSupportUrl}}" target="_blank">Support </a></div>
          <div *ngIf="loggedIn" class="btn btn-default btn-sm text-white btn-primary btn-round headerMenu col-form-label"><a [routerLink]="fmpAdminUrl">Admin</a></div>
        </div>
      </ul>
    </div>

    <div *ngIf="!loggedIn" class="login-wrapper ms-auto">
      <button type ="button" title="For Allison User Only"  (click)="login()"  class="btn btn-login headerMenu">
        Log in
        </button>
    </div>
    <div *ngIf="loggedIn" class="username">
      <br>
      <label class ="form-welcome-label"  for="autoSizingCheck">
        Welcome {{userName}} </label>
        <button type ="button"  (click)="logout()"  class="btn btn-login">
          <fa-icon class="form-check-label "  [icon]="faSignOutAlt"  ></fa-icon>
          Log out
          </button>
    </div>

  </div>


</header>
